import _ from "lodash";
import Cookies from "js-cookie";
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  Ref,
  toRefs,
  watch,
  onActivated,
} from "vue";
import { SalesManService } from "@/components/sales-man-select/sales-man.service";
import { TreeNode, UserRecord } from "./user-select.interface";
import { UserSelectService } from "./user-select.service";
import { useEventbus } from "@/core";
import { bindEmitter } from "@/utils/emitter";
import Icon, { UserOutlined, ForkOutlined } from "@ant-design/icons-vue";
import { Form } from "ant-design-vue";
/**
 * 员工选择器
 *
 * <user-select v-model:value="formRef.userIds"></user-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "UserSelect",
  components: { UserOutlined, ForkOutlined },
  props: {
    value: {
      type: [String, Array] as PropType<string | string[]>,
      default: "",
    },
    userStatus: {
      //转正状态
      type: String,
      default: "",
    },
    // 是否展示员工列表
    showUserList: { type: Boolean, default: true },

    disabled: { type: Boolean, default: false },

    multiple: { type: Boolean, default: false },

    maxCount: { type: Number, default: 1 },
    activatedStatus: {
      type: Number,
      default: undefined,
    },
    status: {
      type: Number,
      default: undefined,
    },
    onJob: {
      type: Boolean,
      default: undefined,
    },
    formName: {
      type: Array,
      default: () => [],
    },
    validate: {
      type: Boolean,
      default: false,
    },
     // 是否有劳务班组
     staffType: { type: [String], default: 'no_type' },
  },
  emits: ["update:value", "change","close"],
  setup(props, { emit }) {
    const state = reactive<{
      visible: boolean;
      userSearchId: string | undefined;
      treeData: TreeNode[];
      loadedKeys: string[];
      expandedKeys: string[];
      tempUsers: UserRecord[];
      selectedUsers: UserRecord[];
      innerMaxCount: Ref<number>;
      selectedUserIds: Ref<string[]>;
      isError: boolean;
      usersStaffType: any, //判断props.staffType 传值是否为null,若为null,props.usersStaffType的值为all,否则不变
    }>({
      visible: false,
      userSearchId: undefined,
      treeData: [],
      loadedKeys: [],
      expandedKeys: [],
      tempUsers: [],
      selectedUsers: [],
      innerMaxCount: computed(() => {
        return props.multiple ? props.maxCount : 1;
      }),
      selectedUserIds: computed(() => {
        return state.selectedUsers.map((item) => item.id);
      }),
      isError: false,
      usersStaffType: computed(()=>{
        return props.staffType ? null:"all"
      }) 
    });
    const { $on } = useEventbus();
    const formItemContext = Form.useInjectFormItemContext();
    const loadDepartment = async ({ row: record }) => {
      const id = record.id;
      const records = await UserSelectService.fetchRecords({ state: props.userStatus,staffType:props.staffType,activatedStatus:props.activatedStatus }, id,state.usersStaffType);
      return records;
    };
    bindEmitter("trigger-form-custom-validator", async () => {
      if (props.validate) {
        if (!props.value) {
          state.isError = true;
          formItemContext.onFieldChange();
          state.tempUsers = [];
        }
      } else {
        if (!props.value) {
          state.tempUsers = [];
        }
      }
    });
    bindEmitter("trigger-keepalive-form-reset", () => {
      state.isError = false;
    });
    $on("form-error", (data) => {
      if (props.formName.length && data.length) {
        let nameString = props.formName.join(",");
        for (let i = 0; i < data.length; i++) {
          let errorString =
            typeof data[i]["name"] == "string" ? data[i]["name"] : data[i]["name"].join(",");
          if (errorString === nameString) {
            state.isError = true;
            break;
          } else {
            state.isError = false;
          }
        }
      }
    });
    const showModal = async () => {
      state.userSearchId=undefined;

      if (props.disabled) return;
      state.visible = true;
      let tmp = await UserSelectService.fetchRecords({ state: props.userStatus,staffType:props.staffType,activatedStatus:props.activatedStatus }, 0);
      tmp.forEach((o: any) => {
        if (o.hasChildren === undefined) {
          o.hasChildren = !o.isLeaf;
        }
      });
      state.treeData = tmp;
    };

    const triggerUpdate = () => {
      const ids = state.tempUsers.map((o: any) => o.id);
      if (state.tempUsers.length === 0) {
        emit("update:value", props.maxCount > 1 ? [] : "");
        emit("change", state.tempUsers);
        formItemContext.onFieldChange();
        return;
      }
      emit("update:value", props.maxCount > 1 ? ids : ids[0]);
      emit("change", state.tempUsers);
      formItemContext.onFieldChange();
    };

    const ok = () => {
      if (state.tempUsers.length > 0) {
        state.isError = false;
      }
      triggerUpdate();
      state.visible = false;
    };

    const deleteTempUser = (deletedId) => {
      state.tempUsers = state.tempUsers.filter((item) => item.id !== deletedId);
    };

    const deleteSelectedUser = (deletedId) => {
      state.tempUsers = state.tempUsers.filter((item) => item.id !== deletedId);
      state.tempUsers.length == 0 && (state.isError = true);
      triggerUpdate();
      emit("close",'')
    };

    const { run } = SalesManService.useSimpleListApi();
    const setSelectedUsers = async (value: string | string[]) => {
      const ids = _.isArray(value) ? value : [value];
      if (ids.length == 0) {
        state.tempUsers = [];
        return;
      }
      const res = await run({ ids });
      if (res.respCode === "0000") {
        state.tempUsers = (res.data?.records || []).reduce((pre: any, cur) => {
          pre.push({ id: cur.id, name: cur.realName,mobile:cur.mobile });
          return pre;
        }, []);
      }
    };

    const onUserSearchSelect = (user) => {
      const tempUserIds = state.tempUsers.map((item) => item.id);
      const { id, realName: name,mobile } = user;
      const userId = UserSelectService.parseUserId(id);
      if (!tempUserIds.includes(userId)) {
        if (props.maxCount > state.tempUsers.length) {
          state.tempUsers.push({ id: userId, name,mobile });
        } else {
          state.tempUsers[props.maxCount - 1] = { id: userId, name,mobile };
        }
      }
    };

    watch(
      () => props.value,
      (n) => {
        state.isError = false;
        if (props.validate) {
          if (!props.value) {
            state.isError = true;
            formItemContext.onFieldChange();
            state.tempUsers = [];
          } else {
            setSelectedUsers(n || []);
            state.isError = false;
          }
        } else {
          if (!props.value) {
            state.tempUsers = [];
          } else {
            setSelectedUsers(n || []);
          }
        }
      },
      { deep: true }
    );

    //点击叶子结点
    const clickRow = (row) => {
      //是叶子结点，同时不是部门节点
      if (row.isLeaf && !row.isDepartment) {
        //判断是否可以多选
        if (props.maxCount > state.tempUsers.length) {
          if (!state.tempUsers.some((o)=>o.id===row.id)) { //检查点击的数组是否有重复的人员id，如果有不添加，如果没有添加进数组
              state.tempUsers.push({ id: row.id, name: row.name,mobile: row.mobile });
          }
        } else {
          state.tempUsers[props.maxCount - 1] = { id: row.id, name: row.name,mobile: row.mobile};
        }
      }
    };
    const cancelFn = () => {
      // state.tempUsers = [];
      state.isError = false;
      if (props.validate) {
        if (!props.value) {
          state.isError = true;
          formItemContext.onFieldChange();
          state.tempUsers = [];
        } else {
          setSelectedUsers(props.value || []);
          state.isError = false;
        }
      } else {
        if (!props.value) {
          state.tempUsers = [];
        } else {
          setSelectedUsers(props.value || []);
        }
      }
    };
    onMounted(() => {
      setSelectedUsers(props.value || []);
      state.isError = false;
    });
    onActivated(() => {
      state.isError = false;
    });
    return {
      ...toRefs(state),
      loadDepartment,
      showModal,
      ok,
      cancelFn,
      deleteTempUser,
      deleteSelectedUser,
      onUserSearchSelect,
      clickRow,
    };
  },
});
